import {Button, Input, Row, Select, Space, Table} from 'antd';
import dayjs from 'dayjs';
import {isEqual} from 'lodash';
import {useState, useEffect} from 'react';
import styled from 'styled-components';
import {colorPalette} from '../../../../config';
import {getInfo} from '../../../../api/admin';
import {getParticipationCount} from '../../../../api/index';
const dateFormat = 'YYYY-MM-DD';

export default function V2GroupTable({
	newGroup,
	setNewGroup,
	isUpdate,
	isUpdateGift = false,
}) {
	const [info, setInfo] = useState({
		id: 0,
		name: '',
		group_started: '',
		group_ended: '',
		volunteer_ended: '',
		// full_num: 0,
		half_num: 0,
		ten_num: 0,
		five_num: 0,
	});
	const [pCount, setPCount] = useState({
		// full: 0,
		half: 0,
		ten: 0,
		five: 0,
	});
	const {Option} = Select;
	const [select, setSelect] = useState({
		selectedRowKeys: [],
		selectedRows: [],
	});
	useEffect(() => {
		(async () => {
			const [res_count, res] = await Promise.all([getParticipationCount(), getInfo()]);
			if (!res.isSuccess || res.data.count !== 1) {
				return alert(
					'현재 정보가 잘못 설정되었습니다. 사무국으로 문의해주세요',
				);
			}

			setInfo({
				...res.data.results[0],
			});
			setPCount(res_count.data.counts);
		})();
	}, []);
	const addGroupItem = () => {
		setNewGroup((prev) => {
			return prev.concat([
				{
					key: `${
						prev.length ? Number(prev[prev.length - 1]?.key) + 1 : 0
					}`,
					name: '',
					gender: '',
					birth: '',
					phone1: '010',
					phone2: '',
					phone3: '',
					course: '',
					gift: '',
				},
			]);
		});
	};

	const onChangeValue = (key, value, name) => {
		const newGroupValue = newGroup.map((prevItem) => {
			if (prevItem.key === key) {
				return {
					...prevItem,
					[name]: value,
				};
			}
			return prevItem;
		});
		setNewGroup(newGroupValue);
	};

	const deleteGroupItem = (key) => {
		const filterGroup = newGroup.filter((item) => item.key !== key);
		setNewGroup(filterGroup);
		setSelect();
	};

	const selectDelete = () => {
		const filterItem = newGroup?.filter((item) => {
			return select?.selectedRows?.every((selectRow) => {
				return selectRow.key !== item.key;
			});
		});

		if (isEqual(newGroup, select.selectedRows)) {
			setSelect({
				selectedRowKeys: [],
				selectedRows: [],
			});
			setNewGroup([]);
		} else {
			setSelect();
			setNewGroup(filterItem);
		}
	};

	const onChangeSelction = (selectedRowKeys, selectedRows) => {
		setSelect({selectedRowKeys, selectedRows});
	};

	const onClickAllItem = () => {
		setSelect({
			selectedRowKeys: newGroup.map((item) => item.key),
			selectedRows: newGroup,
		});
	};

	const getCheckboxProps = (record) => ({
		disabled: record.isDeposit,
		// Column configuration not to be checked
		name: record.name,
	});

	const getGiftOpions = (index) => {
		// if (newGroup?.[index]?.course !== '5km코스') {
		// 	return [{name: '하동특산품(미정)', value: '하동특산품(미정)'}];
		// }
		if (newGroup?.[index]?.course === '하프코스') {
			return [
				{name: '감말랭이,쌀1kg', value: '감말랭이,쌀1kg'},
			];
		}
		if (newGroup?.[index]?.course === '5km코스') {
			return [
				{name: '무릎밴드', value: '무릎밴드'},
			];
		}
		return [
			{name: '감말랭이', value: '감말랭이'},
		];
	};

	const autoHypenPhone = (value) => {
		value = value.replace(/[^0-9]/g, '');
		var newValue = '';
		if (value.length < 5) {
			return value;
		} else if (value.length < 7) {
			newValue += value.substr(0, 4);
			newValue += '-';
			newValue += value.substr(4);
			return newValue;
		} else {
			newValue += value.substr(0, 4);
			newValue += '-';
			newValue += value.substr(4, 2);
			newValue += '-';
			newValue += value.substr(6);
			return newValue;
		}
	};

	// var isDisabledF = true
	var isDisabledH = true
	var isDisabled10 = true
	var isDisabled5 = true
	// if (pCount.full < info.full_num) {
	// 	isDisabledF = false;
	// }
	if (pCount.half < info.half_num) {
		isDisabledH = false;
	}
	if (pCount.ten < info.ten_num) {
		isDisabled10 = false;
	}
	if (pCount.five < info.five_num) {
		isDisabled5 = false;
	}

	const columns = [
		{
			title: '성명',
			dataIndex: 'name',
			render: (text, item) => {
				return (
					<Input
						value={text}
						onChange={(event) => {
							onChangeValue(
								item.key,
								event.target.value.replace(
									/[^\wㄱ-ㅎ|ㅏ-ㅣ|가-힣|ᆞ|ᆢ|ㆍ|ᆢ|ᄀᆞ|ᄂᆞ|ᄃᆞ|ᄅᆞ|ᄆᆞ|ᄇᆞ|ᄉᆞ|ᄋᆞ|ᄌᆞ|ᄎᆞ|ᄏᆞ|ᄐᆞ|ᄑᆞ|ᄒᆞ]/gi,
									'',
								),
								'name',
							);
						}}
						placeholder='홍길동'
					/>
				);
			},
		},
		{
			title: '성별',
			dataIndex: 'gender',
			render: (text, item) => (
				<Select
					defaultValue={text === '' ? null : text}
					placeholder='선택'
					style={{
						width: 100,
					}}
					onChange={(value) => {
						onChangeValue(item.key, value, 'gender');
					}}
					options={[
						{name: '남성', value: '남성'},
						{name: '여성', value: '여성'},
					]}
				/>
			),
		},
		{
			title: '생년월일',
			dataIndex: 'birth',
			render: (text, item) => (
				<Input
					value={text}
					maxLength={10}
					placeholder={dayjs().format(dateFormat)}
					onChange={(event) =>
						onChangeValue(
							item.key,
							autoHypenPhone(event.target.value),
							//dayjs(value).format(dateFormat),
							'birth',
						)
					}
				/>
			),
		},
		{
			title: '휴대폰 번호',
			dataIndex: 'phone',
			width: '300px',
			render: (_, item) => {
				return (
					<Input.Group compact>
						<Select
							value={item.phone1}
							defaultValue='010'
							onChange={(value) => {
								onChangeValue(item.key, value, 'phone1');
							}}
						>
							<Option value='010'>010</Option>
							<Option value='011'>011</Option>
						</Select>

						<Input
							value={item.phone2}
							style={{width: 100, textAlign: 'center'}}
							placeholder='0000'
							maxLength={4}
							onChange={(event) => {
								onChangeValue(
									item.key,
									event.target.value.replace(/[^0-9]/g, ''),
									'phone2',
								);
							}}
						/>

						<Input
							value={item.phone3}
							className='site-input-right'
							style={{
								width: 100,
								textAlign: 'center',
							}}
							placeholder='0000'
							maxLength={4}
							onChange={(event) => {
								onChangeValue(
									item.key,
									event.target.value.replace(/[^0-9]/g, ''),
									'phone3',
								);
							}}
						/>
					</Input.Group>
				);
			},
		},
		{
			title: '종목',
			dataIndex: 'course',
			render: (text, item) => (
				<Select
					style={{width: 100}}
					placeholder='선택'
					defaultValue={text === '' ? null : text}
					onChange={(value) => {
						onChangeValue(item.key, value, 'course');
					}}
					// 코스 비활성화 disabled: true
					options={[
						// {name: '풀코스', value: '풀코스', disabled: isDisabledF},
						{name: '하프코스', value: '하프코스', disabled: isDisabledH},
						{name: '10km코스', value: '10km코스', disabled: isDisabled10},
						// {name: '5km코스', value: '5km코스', disabled: isDisabled5},
					]}
					disabled={item?.isLoadData}
				></Select>
			),
		},
		// {
		// 	title: '기념품 옵션',
		// 	dataIndex: 'gift',
		// 	render: (text, item) => (
		// 		<CustomSelect
		// 			style={{width: 120}}
		// 			placeholder='선택'
		// 			// 기념품이 하나라면 placeholder 지우고 밑의 두줄 주석 풀기
		// 			// value={text}
		// 			// defaultValue='하프코스'
		// 			onChange={(value) => {
		// 				onChangeValue(item.key, value, 'gift');
		// 			}}
		// 			defaultValue={text === '' ? null : text}
		// 			disabled={isUpdateGift}
		// 			options={getGiftOpions(Number(item?.key ?? 0))}
		// 		></CustomSelect>
		// 	),
		// },
		{
			title: '삭제',
			dataIndex: '',
			key: 'x',
			width: '9%',
			render: (value, item) => {
				if (item?.isDeleted) {
					return <StyledText2>신청취소상태</StyledText2>;
				}
				if (item?.isDeposit) {
					return <StyledText2>입금완료</StyledText2>;
				}
				return (
					<StylesButton
						type='primary'
						onClick={() => deleteGroupItem(item.key)}
					>
						삭제
					</StylesButton>
				);
			},
		},
	];
	return (
		<>
			<Header justify='space-between'>
				<div>
					<StyledText>
						총인원수 : <b>{newGroup?.length}</b> 명
					</StyledText>
					<StyledSubText>
						* 단체 신청은 기본 2명 이상 신청 가능합니다.
					</StyledSubText>
				</div>
				<Row style={{marginTop: 33}}>
					<Space size='large'>
						<StyledButton2 onClick={onClickAllItem}>
							전체선택
						</StyledButton2>
						<StyledButton2 onClick={addGroupItem}>
							인원추가
						</StyledButton2>
						<StyledButton2 onClick={selectDelete}>
							선택삭제
						</StyledButton2>
					</Space>
				</Row>
			</Header>
			<Table
				scroll={{x: 1170, y: 650}}
				rowSelection={{
					...select,
					getCheckboxProps,
					onChange: onChangeSelction,
					type: 'checkbox',
				}}
				columns={columns}
				dataSource={newGroup}
				pagination={false}
			/>
		</>
	);
}

const Header = styled(Row)({
	marginBottom: 20,
});

const StylesButton = styled(Button)({
	background: colorPalette.primary,
	'&&:hover': {
		background: colorPalette.primary,
	},
});

const StyledText = styled.p({
	fontSize: '1.125rem',
	marginBottom: '6px',
});

const StyledSubText = styled.p({
	fontSize: '0.875rem',
	color: '#d54343',
	marginTop: 0,
	marginBottom: 0,
});

const StyledButton2 = styled(Button)({
	border: '1px solid #414c80',
	color: colorPalette.primary,
	fontSize: '1.125rem',
	height: '2.5rem',
	borderRadius: '2rem',
	padding: '0 1.5rem',
	'@media screen and (max-width: 450px)': {
		padding: '0 1rem',
	},
	'&&:hover': {
		border: '1px solid #414c80',
		color: colorPalette.primary,
	},
});

const StyledText2 = styled.p({});

const CustomSelect = styled(Select)({});
